//import dependencies
import '../styles/output.css'
import '../styles/global.css'
import Card from './Card'
//Return skills and experience section 
let Skills=()=>{
    return(
        <div className='main flex flex-col sm:flex-row sm:justify-start sm:flex-wrap sm:gap-x-2.5 px-2 py-3 bg-neutral-950 break-2:px-9 break-2:justify-between'>
            {/* Software skills below (Photoshop, Illustrator respectively)*/}
            <div>
                {/* Header container */}
                <div className='py-4'>
                  <h3 className='font-bold text-xl text-white py-1 underline decoration-yellow-400'>Software skills</h3>
                 </div>
                  {/* Software skills progress bars (Photoshop, Illustrator respectively)*/}
                <div className='flex flex-col items-center pl-8'>
                    <Card title='Adobe Photoshop' src='/images/icons/pngwing.com (2).png' className='mb-3'>
                      <progress  max={100} value={95}></progress>
                    </Card>
                    <Card title='Adobe Illustrator' src='/images/icons/pngwing.com (1).png' className='mb-3'>
                      <progress  max={100} value={80}></progress>
                    </Card>
                </div>
            </div>
            {/* Hobbies and Interests */}
            <div>
                 <div className='py-4'>
                  <h3 className='font-bold text-xl text-white py-1'>Hobbies and Interests</h3>
                 </div>
                 {/* I should've customized the card component to provide vertical cards here :) */}
                <div className='flex flex-row justify-center pr-8'>
                {/* Interest 1 */}
                <div className='flex flex-col bg-white p-3 mx-2'>
                    <img src='/images/icons/basketball-svgrepo-com.svg' alt='' className='size-20'/>
                    <span className='text-center font-semibold'>Basketball</span>
                </div>
                {/* Interest 2 */}
                <div className='flex flex-col bg-white p-3 mx-2'>
                    <img src='/images/icons/gym-svgrepo-com.svg' alt='' className='size-20'/>
                    <span className='text-center font-semibold'>Gym</span>
                </div>
            </div>
            </div>
            {/* Youtube channel section */}
            <div className=''>
                <div className='flex flex-col items-start font-bold'>
                    <h3 className='text-xl text-white m-2 underline decoration-yellow-400'>My Workflow</h3>
                    <div className='flex flex-col items-center font-bold'>
                        <iframe src='https://www.youtube.com/embed/si1ktIiHyEQ?si=xRcCRBjeOnQLJiat' width="425" height="315" title='cy'></iframe>
                    </div>  
                </div>
            </div>
            <div>
                <h3 className='text-xl text-white m-2 underline decoration-yellow-400'>FAQs</h3>
                <img src='/images/works/about my work.png' alt=''/>
            </div>
        </div>
    )
}
export default Skills